import { Dispatch } from '@reduxjs/toolkit'
import { userSlice } from '../slices'
import { UserDAO } from '../models'

declare global {
  interface Window {
    FS: any
  }
}

function getUser() {
  return async (dispatch: Dispatch): Promise<void> => {
    const userDAO = new UserDAO()
    const user = await userDAO.get()

    if (user) {
      dispatch(userSlice.actions.setUser(user))

      window.FS?.identify(user.id, {
        displayName: user.name,
        email: user.email
      })
    }
  }
}

export function getIsFrom() {
  return async (dispatch: Dispatch): Promise<void> => {
    const userDAO = new UserDAO()

    userDAO.getIsFromBrazil().then(({ isFromBrazil }) => {
      dispatch(userSlice.actions.updateUser({ isFromBrazil }))
    })
  }
}

export default getUser
